/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/1/19
 * Time: 10:23 AM
 */
import * as actionTypes from "./actionTypes";
import Cookies from "js-cookie";
import axios from "../../axios/axios_visitortag";
import {checkErrorResponse} from "./Reception_SheduleMeetingActions";
import apiConfig from "../../axios/axios_api_services";

export const visitorAllCountsHandler = (data) => {
  return {
    type: actionTypes.VISITOR_COUNT_LIST,
    value: data
  }
};

export const callAllCount = (usr_obj) => {
  const headers = {
    "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
  };

  let coperateId = usr_obj.corporates[0].corporateId;

  return dispatch => {

    axios.get(apiConfig.CORPORATE_ALL_VISITORS_COUNT(coperateId), {headers: headers})
      .then(response => {

        if (response.data.success) {
          dispatch(visitorAllCountsHandler(response.data.counts));
        } else {
          dispatch(visitorAllCountsHandler({
            checkOut: 0,
            notCheckOut: 0,
            total: 0,
            overdue: 0,
          }));
        }
      })

      .catch(error => {
        dispatch(checkErrorResponse(error, usr_obj, 3));
      });
  };
};

// export const checkErrorResponse = (error, usr_obj, type) => {
//
//   if (error !== undefined) {
//     if (error.response === undefined) {
//       notifyMessage("Your connection was interrupted!", 1, 3);
//     } else if (error.response.status === 401) {
//
//       const headers = {
//         "Content-Type": "application/x-www-form-urlencoded",
//         "Authorization": "Basic " + config.CLIENT_SECRET
//       };
//       let refresh_token = Cookies.get('9b8558ba3f051677daf36ebfc67f29fa');
//
//       const data_ = {
//         grant_type: "refresh_token",
//         refresh_token: refresh_token
//       };
//
//       // Get Access token from refresh token
//       return dispatch => {
//         axios_authentication.post(`oauth/token`, qs.stringify(data_), {headers: headers})
//           .then(response => {
//             console.log("checking");
//             Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token); //access-token (68a6102f6ed24899420170004a0273b8)
//             if (type === 3) {
//               dispatch(callAllCount(usr_obj));
//             }
//           })
//           .catch(error => {
//             swal({
//               title: "Your token expired! Please re-enter login credentials \n Thank you",
//               icon: are_you_sure_icon,
//               closeOnClickOutside: false,
//               buttons: {
//                 dangerMode: {
//                   text: "Okay",
//                   value: "action",
//                   className: "warning-btn"
//                 }
//               },
//             })
//               .then((value) => {
//                 switch (value) {
//
//                   case "action":
//                     Cookies.remove("68a6102f6ed24899420170004a0273b8");
//                     Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
//                     window.location.href = "/";
//
//                     break;
//                   default:
//                 }
//               });
//           });
//       }
//     } else if (error.response.status === 403) {
//       notifyMessage("Sorry, your can't access!", 1, 3);
//     } else {
//       notifyMessage("Your connection was interrupted!", 1, 3);
//     }
//   } else {
//     notifyMessage("Your connection was interrupted!", 1, 3);
//   }
// };
